module.exports = __webpack_public_path__ + "img/1584655709085761060.7043c16e.jpg";